module.exports = __webpack_public_path__ + "static/img/07.229bf8e1.png";